import request from '@/utils/request'

/**
 * 需求分页列表
 * @param data
 */
export const myNeedList = (data) => {
  return request({
    url: '/sol/wap/reqs/page',
    method: 'post',
    data: data
  })
}
/**
 * 需求详情
 * @param data
 */
export const getNeed = (reqId) => {
  return request({
    url: `/sol/wap/reqs/detail/${reqId}`,
    method: 'get'
  })
}

/**
 * 定制方案分页列表
 * @param data
 */
export const myCaseList = (params) => {
  return request({
    url: '/sol/wap/reqs/order/page',
    method: 'GET',
    params
  })
}
/**
 * 定制方案详情
 * @param data
 */
export const getMycase = (orderNo) => {
  return request({
    url: `/sol/wap/reqs/order/${orderNo}?time=${new Date().getTime()}`,
    method: 'get'
  })
}
/**
 * 定制方案支付
 * @param data
 */
export const creatOrderInfo = (data) => {
  return request({
    url: '/sol/wap/payment/creatOrderInfo',
    method: 'post',
    data: data
  })
}
/**
 * 更新设计任务状态
 * @param data
 */
export const changeStatue = (params) => {
  return request({
    url: '/sol/wap/reqs/update',
    method: 'put',
    params
  })
}
/**
 * 审核|取消
 * @param data
 */
export const changehandle = (data) => {
  return request({
    url: '/sol/wap/reqs/handle',
    method: 'POST',
    data: data
  })
}
/**
 * 一键发布
 * @param data
 */
export const putRelease = (data) => {
  return request({
    url: '/sol/wap/reqs/simple',
    method: 'POST',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/userPerson/userPerson.js